import React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Icon from '@material-ui/core/Icon';
import MenuItem from '@material-ui/core/MenuItem';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import IconButton from '@material-ui/core/IconButton';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import CustomDialog from './inputs/CustomDialog'
import CustomOutlinedButton from './Mui/CustomOutlinedButton';
import InnerBar from './InnerBar'
import SkillForm from './SkillForm'
import TagForm from './TagForm'
import TextInput from './inputs/TextInput'
import LevelSubForm from './LevelSubForm'
import LevelLabels from './LevelLabels'
import FormSelect from './inputs/FormSelect'
// import CompetencyForm from './CompetencyForm'
import CompetencySubForm from './CompetencySubForm'

import shortid from 'shortid'

import {
  is_logged_on,
  is_validating,
  theme
 } from "../helpers"

import {
  LocalForm,
  Control,
  actions,
  track
} from 'react-redux-form'

import {
  isRequired,
  isNumeric,

} from "../validators"

import {
  preferences_index,
  update_preferences,
  reset_preferences
} from '../actions'

const mapDispatchToProps = dispatch => {
  return {
    resetPreferences: () => dispatch( reset_preferences() ),
    getPreferences: () => dispatch( preferences_index() ),
    updatePreferences: (values) => dispatch ( update_preferences(values) )
  };
};

const mapStateToProps = (state) => {
  return {
    current_user: state.auth.current_user.data,
    skills: state.skill.items,
    skill_errors: state.skill.errors,
    competencies: state.competency.items,
    competency_errors: state.competency.errors,
    tags: state.tag.items,
    tag_errors: state.tag.errors,
    preferences: state.preference.preferences,
    seconds: state.preference.preferences.question_seconds,
    levels: state.preference.levels,
    preferences_errors: state.preference.errors,
    fetched_prefs: state.preference.fetched,
    fetching_prefs: state.preference.fetching,
    mustRedirect: state.preference.mustRedirect
  };
}


class ConnectedSettings extends React.Component {
  constructor() {
    super()
    this.state = {
      justLoaded: false,
      formValid: false,
      formData: null,
      numberValid: true,
      minutesValid: true,
      secondsValid: true,

      // B2B Free Plan coupon Settings
      freePlanRedeems: true,
      freePlanDiscount: true,

      // B2B Users messages
      confirmB2BTitleValid: true,
      confirmB2BBodyValid: true,
      newVoucherTitleValid: true,
      newVoucherBodyValid: true,
      revokedVoucherTitleValid: true,
      revokedVoucherBodyValid: true,

      resetTitleValid: true,
      resetBodyalid: true,

      confirmTitleValid: true,
      confirmBodyValid: true,

      terminateTitleValid: true,
      terminateBodyValid: true,

      receiptTitleValid: true,
      receiptBodyalid: true,
      receiptFreeBodyalid: true,

      preregisterTitleValid: true,
      preregisterBodyalid: true,
      // new
      adminMailValid: true,
      certificateTitleValid: true,
      systemUrlValid: true,
      testUrlValid: true,
      b2bUrlValid: true,
      testPriceValid: true,

      accountingEmailValid: true,
      fromEmailValid: true,
      contactPhoneValid: true,
      vatValid: true,
      addressValid: true,
      termsValid: true,
      policyValid: true,

      localSkills: [],
      skillopen: false,
      skillsValid: true,
      skillError: '',

      localCompetencies: [],
      competencyopen: false,
      competencyError: '',

      seconds: 0,

      tagopen: false,
      localTags: [],
      tagsValid: true,
      tagError: '',
      current_tag: null,
      showTagDialog: false,
      tagQuestions: 0,

      levelErrors: { A1: {}, A2: {}, B1: {}, B2: {}, C1: {}, C2: {} }
    }
  }

  attachDispatch(dispatch) {
    this.formDispatch = dispatch;
  }

  componentWillMount() {
    this.props.getPreferences()
  }

  componentDidUpdate(prevProps, prevState){
    // let newCompetencyErrors
    if (prevProps.skills.length === 0 && this.props.skills.length > 0  ) {
      this.setState({
        localSkills: [...this.props.skills],
        seconds: this.props.seconds
      })
    }
    if (prevProps.competencies.length !== this.props.competencies.length  ) {

      this.setState({
        localCompetencies: this.props.competencies,
      })
    } else if (this.state.localCompetencies.length === 0 && this.props.competencies.length > 0) {
      this.setState({
        localCompetencies: this.props.competencies,
      })
    }

    if (prevProps.tags.length === 0 && this.props.tags.length > 0 ) {
      this.setState({
        localTags: [...this.props.tags]
      })
    }

    if ((this.props.mustRedirect && !prevProps.mustRedirect) || !this.state.justLoaded ) {
      this.setState({
        localSkills: this.props.skills,
        localTags: this.props.tags,
      })
      if ( this.state.justLoaded ) {
        window.showSnackbar('success', 'Settings have been updated.')
      } else {
        this.setState({ justLoaded: true })
      }
    }
  }

  checkValid() {
    this.formDispatch( actions.setDirty('settings.question_seconds') )
    this.formDispatch( actions.setDirty('settings.template_minutes') )
    this.formDispatch( actions.setDirty('settings.template_questions') )
    this.formDispatch( actions.setDirty('settings.mail_reset_title') )
    this.formDispatch( actions.setDirty('settings.mail_reset_body') )
    this.formDispatch( actions.setDirty('settings.mail_confirm_title') )
    this.formDispatch( actions.setDirty('settings.mail_confirm_body') )
    this.formDispatch( actions.setDirty('settings.mail_terminate_user_title') )
    this.formDispatch( actions.setDirty('settings.mail_terminate_user_body') )
    this.formDispatch( actions.setDirty('settings.mail_b2b_confirm_title') )
    this.formDispatch( actions.setDirty('settings.mail_b2b_confirm_body') )
    this.formDispatch( actions.setDirty('settings.mail_receipt_title') )
    this.formDispatch( actions.setDirty('settings.mail_receipt_body') )
    this.formDispatch( actions.setDirty('settings.mail_receipt_free_body') )
    this.formDispatch( actions.setDirty('settings.mail_certificate_title') )
    this.formDispatch( actions.setDirty('settings.admin_email') )
    this.formDispatch( actions.setDirty('settings.b2b_url') )
    this.formDispatch( actions.setDirty('settings.b2b_templates_title') )
    // B2B free plan
    this.formDispatch( actions.setDirty('settings.free_plan_redeems') )
    this.formDispatch( actions.setDirty('settings.free_plan_discount') )

    this.formDispatch( actions.setDirty('settings.test_url') )
    this.formDispatch( actions.setDirty('settings.system_url') )
    this.formDispatch( actions.setDirty('settings.test_price') )
    this.formDispatch( actions.setDirty('settings.accounting_email') )
    this.formDispatch( actions.setDirty('settings.from_email') )
    this.formDispatch( actions.setDirty('settings.contact_phone') )
    this.formDispatch( actions.setDirty('settings.vat') )
    this.formDispatch( actions.setDirty('settings.address') )
    this.formDispatch( actions.setDirty('settings.disclaimer_label') )
    this.formDispatch( actions.setDirty('settings.disclaimer_text') )
    this.formDispatch( actions.setDirty('settings.email_disclaimer_label') )
    this.formDispatch( actions.setDirty('settings.email_disclaimer_text') )
    this.formDispatch( actions.setDirty('settings.terms_of_service') )
    this.formDispatch( actions.setDirty('settings.privacy_policy') )

    const competenciesValid = this.state.localCompetencies.filter( c => c.invalid ).length === 0

    const isValid = this.state.formData.$form.valid && competenciesValid

    if (!isValid) {
      window.showSnackbar('error', 'Please fill in all mandatory fields.')
    }

    return isValid
  }

  handleSubmit(values) {
    if (this.checkValid()) {
      const allValues = {
        ...values,
        skills: this.state.localSkills,
        competencies: this.state.localCompetencies.map( c => {
          const {id, name, ratio} = c
          return { id, name, ratio }
        }),
        tags: this.state.localTags
      }
      this.props.updatePreferences(allValues)
    }
  }

  handleUpdate(form) {
    const {
      question_seconds, template_questions, template_minutes, levels,
      mail_reset_title, mail_reset_body, mail_confirm_title, mail_confirm_body,
      mail_b2b_confirm_title, mail_b2b_confirm_body, mail_terminate_user_title, mail_terminate_user_body,
      mail_new_voucher_title, mail_new_voucher_body, mail_revoked_voucher_title, mail_revoked_voucher_body,
      mail_receipt_title, mail_receipt_body, mail_receipt_free_body,
      mail_preregister_title, mail_preregister_body,
      mail_certificate_title, admin_email, system_url, test_url, b2b_url, b2b_templates_title, test_price,
      accounting_email, from_email, contact_phone, vat, address,
      disclaimer_label, disclaimer_text, terms_of_service, privacy_policy,
      email_disclaimer_label, email_disclaimer_text,
      free_plan_redeems, free_plan_discount,
      $form } = form

    const numberState = (template_questions.pristine || template_questions.valid)
    const minutesState = (template_minutes.pristine || template_minutes.valid)
    const secondsState = (question_seconds.pristine || question_seconds.valid)
    const resetTitleState = (mail_reset_title.pristine || mail_reset_title.valid)
    const resetBodyState = (mail_reset_body.pristine || mail_reset_body.valid)
    const confirmTitleState = (mail_confirm_title.pristine || mail_confirm_title.valid)
    const confirmBodyState = (mail_confirm_body.pristine || mail_confirm_body.valid)
    const terminateTitleState = (mail_terminate_user_title.pristine || mail_terminate_user_title.valid)
    const terminateBodyState = (mail_terminate_user_body.pristine || mail_terminate_user_body.valid)
    const confirmB2BTitleState = (mail_b2b_confirm_title.pristine || mail_b2b_confirm_title.valid)
    const confirmB2BBodyState = (mail_b2b_confirm_body.pristine || mail_b2b_confirm_body.valid)
    const newVoucherTitleState = (mail_new_voucher_title.pristine || mail_new_voucher_title.valid)
    const newVoucherBodyState = (mail_new_voucher_body.pristine || mail_new_voucher_body.valid)
    const revokedVoucherTitleState = (mail_revoked_voucher_title.pristine || mail_revoked_voucher_title.valid)
    const revokedVoucherBodyState = (mail_revoked_voucher_body.pristine || mail_revoked_voucher_body.valid)
    const receiptTitleState = (mail_receipt_title.pristine || mail_receipt_title.valid)
    const receiptBodyState = (mail_receipt_body.pristine || mail_receipt_body.valid)
    const receiptFreeBodyState = (mail_receipt_free_body.pristine || mail_receipt_free_body.valid)
    const preregisterTitleState = (mail_preregister_title.pristine || mail_preregister_title.valid)
    const preregisterBodyState = (mail_preregister_body.pristine || mail_preregister_body.valid)
    const certificateTitleState = (mail_certificate_title.pristine || mail_certificate_title.valid)
    const adminMailState = (admin_email.pristine || admin_email.valid)
    const systemUrlState = (system_url.pristine || system_url.valid)
    const testUrlState = (test_url.pristine || test_url.valid)
    const b2bUrlState = (b2b_url.pristine || b2b_url.valid)
    const b2bTemplatesTitleState = (b2b_templates_title.pristine || b2b_templates_title.valid)
    // B2B free plan coupon
    const b2bFreePlanRedeemsState = (free_plan_redeems.pristine || free_plan_redeems.valid)
    const b2bFreePlanDiscountState = (free_plan_discount.pristine || free_plan_discount.valid)

    const testPriceState = (test_price.pristine || test_price.valid)
    const accountingEmailState = (accounting_email.pristine || accounting_email.valid)
    const fromEmailState = (from_email.pristine || from_email.valid)
    const contactPhoneState = (contact_phone.pristine || contact_phone.valid)
    const vatState = (vat.pristine || vat.valid)
    const termsState = (terms_of_service.pristine || terms_of_service.valid)
    const policyState = (privacy_policy.pristine || privacy_policy.valid)
    const addressState = (address.pristine || address.valid)
    const disclaimerLabelState = (disclaimer_label.pristine || disclaimer_label.valid)
    const disclaimerTextState = (disclaimer_text.pristine || disclaimer_text.valid)
    const emailDisclaimerLabelState = (email_disclaimer_label.pristine || email_disclaimer_label.valid)
    const emailDisclaimerTextState = (email_disclaimer_text.pristine || email_disclaimer_text.valid)

    let levelErrors = {}

    Object.keys(levels).forEach( (key) => {
      if ( key === "$form") {
        return
      }
      const {name, score_right, score_wrong, level_up, level_down, min_average, msr, label, description} = levels[key]
      const level = {score_right, score_wrong, level_up, level_down, min_average, msr, label, description}
      levelErrors[name.value] = {
        score_right: !level.score_right.valid,
        score_wrong: !level.score_wrong.valid,
        level_up: !level.level_up.valid,
        level_down: !level.level_down.valid,
        min_average: !level.min_average.valid,
        msr: !level.msr.valid,
        label: !level.label.valid,
        description: !level.description.valid,
      }
    })

    this.setState({
      formValid: $form.valid && this.state.skillsValid && this.state.tagsValid,
      numberValid: numberState,
      minutesValid: minutesState,
      secondsValid: secondsState,
      resetTitleValid: resetTitleState,
      resetBodyalid: resetBodyState,
      confirmTitleValid: confirmTitleState,
      confirmBodyValid: confirmBodyState,
      terminateTitleValid: terminateTitleState,
      terminateBodyValid: terminateBodyState,
      confirmB2BTitleValid: confirmB2BTitleState,
      confirmB2BBodyValid: confirmB2BBodyState,
      newVoucherTitleValid: newVoucherTitleState,
      newVoucherBodyValid: newVoucherBodyState,
      revokedVoucherTitleValid: revokedVoucherTitleState,
      revokedVoucherBodyValid: revokedVoucherBodyState,
      receiptTitleValid: receiptTitleState,
      receiptBodyalid: receiptBodyState,
      preregisterTitleValid: preregisterTitleState,
      preregisterBodyValid: preregisterBodyState,
      receiptFreeBodyalid: receiptFreeBodyState,
      certificateTitleValid: certificateTitleState,
      adminMailValid: adminMailState,
      systemUrlValid: systemUrlState,
      testUrlValid: testUrlState,
      b2bUrlValid: b2bUrlState,
      b2bTemplatesTitleValid: b2bTemplatesTitleState,
      // B2B free plan coupon
      b2bFreePlanRedeemsValid: b2bFreePlanRedeemsState,
      b2bFreePlanDiscountValid: b2bFreePlanDiscountState,

      testPriceValid: testPriceState,
      accountingEmailValid: accountingEmailState,
      fromEmailValid: fromEmailState,
      contactPhoneValid: contactPhoneState,
      vatValid: vatState,
      termsValid: termsState,
      policyValid: policyState,
      addressValid: addressState,
      disclaimerLabelValid: disclaimerLabelState,
      disclaimerTextValid: disclaimerTextState,
      emailDisclaimerLabelValid: emailDisclaimerLabelState,
      emailDisclaimerTextValid: emailDisclaimerTextState,
      formData: form,
      skillopen: false,
      competencyopen: false,
      levelErrors: levelErrors
    })
  }

  handleClose() {
    this.setState({skillopen: false, competencyopen:false, tagopen: false})
  }

  handleSkill(e, id) {
    const newSkills = this.state.localSkills.map( skill =>{
      if (skill.id === id) {
        return {
          ...skill,
          name: e.target.value
        }
      }
      return skill
    })
    this.setState({
      localSkills: newSkills,
      skillsValid: (e.target.value && e.target.value !== '')
    })
  }

  handleCompetency(e, id, field="name") {
    // const isValid = e.target.value && e.target.value.length > 0 && this.state.localCompetencies.filter( c => c.name === e.target.value && c.id !== id).length === 0
    const newCompetencies = this.state.localCompetencies.map( competency =>{
      const newRatio = (field === "ratio") ? e.target.value : ((competency.ratio === undefined) ? 1 : competency.ratio)
      if (competency.id === id) {
        return {
          ...competency,
          name: field === "name" ? e.target.value : competency.name,
          ratio: isNumeric(newRatio, true) ? parseInt(newRatio, 10) : '',
          invalid: !isNumeric(newRatio, true), // allowZero
        }
      }
      return {
        ...competency
      }
    })

    this.setState({
      localCompetencies: newCompetencies,
    })
  }

  handleTag(e, id) {
    const newTags = this.state.localTags.map( tag =>{
      if (tag.id === id) {
        return {
          ...tag,
          name: e.target.value
        }
      }
      return tag
    })
    this.setState({
      localTags: newTags,
      tagsValid: (e.target.value && e.target.value !== '')
    })
  }

  handleChangeSeconds(e) {
    const { value } = e.target
    this.formDispatch(actions.change('settings.seconds', value))
    this.setState({seconds: value})
  }

  addSkill(values) {
    const checkSkills = this.state.localSkills.filter( skill => skill.name === values.name )
    if ( checkSkills.length === 0 ) {
      const newSkills = [
        ...this.state.localSkills,
        {
          id: shortid.generate(),
          questions: 0,
          templates: 0,
          users: 0,
          name: values.name
        }
      ].sort( (a,b) => a.name > b.name )
      this.setState({skillopen: false, localSkills: newSkills, skillError: ''})
    } else {
      this.setState({skillError: 'Skill Exists'})
    }
  }

  // addCompetency(values) {
  //   const checkCompetencies = this.state.localCompetencies.filter( competency => competency.name === values.name )
  //   if ( checkCompetencies.length === 0 ) {
  //     const newId = shortid.generate()
  //     const newCompetencies = [
  //       ...this.state.localCompetencies,
  //       {
  //         id: newId,
  //         questions: 0,
  //         name: values.name,
  //         ratio: 1,
  //         invalid: false
  //       }
  //     ].sort( (a,b) => a.name > b.name )
  //
  //     this.setState({competencyopen: false, localCompetencies: newCompetencies, competencyError: ''})
  //   } else {
  //     this.setState({competencyError: 'Competency Exists'})
  //   }
  // }

  addTag(values) {
    const checkTags = this.state.localTags.filter( tag => tag.name === values.name )
    if ( checkTags.length === 0 ) {
      const newTags = [
        ...this.state.localTags,
        {
          id: shortid.generate(),
          questions: 0,
          name: values.name
        }
      ].sort( (a,b) => a.name > b.name )
      this.setState({tagopen: false, localTags: newTags, tagError: ''})
    } else {
      this.setState({tagError: 'Tag Exists'})
    }
  }

  deleteSkill(id) {
    const newSkills = this.state.localSkills.filter( skill => skill.id !== id )
    this.setState({localSkills: newSkills})
  }

  deleteCompetency(id) {
    const newCompetencies = this.state.localCompetencies.filter( competency => competency.id !== id )
    this.setState({localCompetencies: newCompetencies})
  }

  deleteTag(id) {
    const newTags = this.state.localTags.filter( tag => tag.id !== id )
    this.setState({localTags: newTags})
  }

  hideDialog() {
    this.setState({
      current_tag: null,
      showTagDialog: false,
      tagQuestions: 0
    })
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    if ( is_validating() ) {
      return ''
    }

    const { current_user } = this.props

    if ( current_user.role !== 'admin') {
      return <Redirect to="/" />
    }

    if ( this.props.preferences.template_questions === null || this.props.preferences.template_questions === undefined ) {
      return ''
    }

    const saveButton = (
      <div className="d-flex">
        <CustomOutlinedButton
          className="buttonnoto c-blue align-self-center"
          onClick={e => {
            this.formDispatch( actions.submit('settings') )
          }}>SAVE</CustomOutlinedButton>
      </div>
    )

    const {
      question_seconds, template_minutes, template_questions,
      mail_reset_title, mail_reset_body, mail_terminate_user_title, mail_terminate_user_body,
      mail_confirm_title, mail_confirm_body, mail_b2b_confirm_title, mail_b2b_confirm_body,
      mail_new_voucher_title, mail_new_voucher_body, mail_revoked_voucher_title, mail_revoked_voucher_body,
      mail_receipt_title, mail_receipt_body, mail_receipt_free_body,
      mail_preregister_title, mail_preregister_body,
      mail_certificate_title, admin_email, system_url, test_url, b2b_url, b2b_templates_title,
      accounting_email, from_email, contact_phone, vat, address,
      disclaimer_label, disclaimer_text, terms_of_service, privacy_policy,
      email_disclaimer_label, email_disclaimer_text, test_price,
      free_plan_redeems, free_plan_discount,
    } = this.props.preferences
    const { levels, competencies } = this.props

    const initialState = {
      question_seconds, template_minutes, template_questions,
      mail_reset_title, mail_reset_body, mail_terminate_user_title, mail_terminate_user_body,
      mail_confirm_title, mail_confirm_body, mail_b2b_confirm_title, mail_b2b_confirm_body,
      mail_new_voucher_title, mail_new_voucher_body, mail_revoked_voucher_title, mail_revoked_voucher_body,
      mail_receipt_title, mail_receipt_body, mail_receipt_free_body,
      mail_preregister_title, mail_preregister_body,
      mail_certificate_title, admin_email, system_url, test_url, b2b_url, b2b_templates_title,
      accounting_email, from_email, contact_phone, vat, address,
      disclaimer_label, disclaimer_text, terms_of_service, privacy_policy,
      email_disclaimer_label, email_disclaimer_text, test_price, levels, competencies,
      free_plan_redeems, free_plan_discount,
    }

    return (
      <MuiThemeProvider theme={theme}>
        <Grid container spacing={24}>
          <Grid item xs={12}>

            <div className="d-flex justify-content-between mb-40">

              <Typography className="fw-bold h4">
              Settings
              </Typography>

              { saveButton }

            </div>

            <Paper use="skills" className="mb-24 innerbar">
              <InnerBar text="General"/>

              <div className="pl-24 pr-24 pt-24 pb-24">
                <Typography className="h6 mb-24">Skills</Typography>
                <Grid item xs={12} md={8}>
                  <Grid item xs={12} container spacing={24}>
                  {
                    this.state.localSkills.map( skill => {
                      const {id, name, questions, templates, users} = skill
                      const isEnabled = ((questions === 0 || (questions && questions.total === 0)) && templates === 0 && users === 0)
                      const delIcon = (isEnabled) ? (
                        <IconButton title="Delete this skill"
                          onClick={e=>{
                            this.deleteSkill(id)
                        }}>
                          <Icon style={{color: 'black'}} aria-label="Delete">delete_forever</Icon>
                        </IconButton>
                      ) : (
                        <IconButton aria-label="Delete" disabled>
                          <DeleteForeverIcon />
                        </IconButton>
                      )
                      return (
                        <Grid item xs={12} sm={6} key={`skillform-${id}`}>
                          <div className="d-flex">
                            <div className="flex-1">
                              <span title={(isEnabled) ? "" : "There are Questions, Templates or Users that depend on this skill" }>
                                <TextInput
                                  id={`skill-${id}`}
                                  key={id}
                                  multiline={true}
                                  rowsMax={6}
                                  nocontrol={true}
                                  defaultValue={name}
                                  helperText="Skill Name"
                                  onChange={e=> {
                                    this.handleSkill(e, id)
                                  }}
                                />

                              </span>
                            </div>
                            <div className="align-self-center">
                            { delIcon }
                            </div>
                          </div>
                        </Grid>
                      )
                    })
                  }
                  </Grid>
                </Grid>

              </div>
              <div>
                <Grid item xs={12} md={8}>
                <div className="d-flex justify-content-end mt-24 pb-24 pr-160 mr-16">
                  <CustomOutlinedButton
                    className="buttonnoto c-blue"
                    onClick={e => {
                      e.preventDefault()
                      this.setState({skillopen:true})
                    }}
                  >ADD</CustomOutlinedButton>
                </div>
                </Grid>
              </div>
{

              //
              // <div className="pl-24 pr-24 pt-24 pb-24">
              //   <Typography className="h6 mb-24">Competencies</Typography>
              //   <Grid item xs={12} md={8}>
              //     <Grid item xs={12} container spacing={24}>
              //     {
              //       this.state.localCompetencies.map( competency => {
              //         const {id, name, questions} = competency
              //         const isEnabled = (questions === 0 || (questions && questions.total === 0))
              //         const delIcon = (isEnabled) ? (
              //           <IconButton title="Delete this competency"
              //             onClick={e=>{
              //               this.deleteCompetency(id)
              //           }}>
              //             <Icon style={{color: 'black'}} aria-label="Delete">delete_forever</Icon>
              //           </IconButton>
              //         ) : (
              //           <IconButton aria-label="Delete" disabled>
              //             <DeleteForeverIcon />
              //           </IconButton>
              //         )
              //         return (
              //           <Grid item xs={12} sm={6} key={`competencyform-${id}`}>
              //           <div className="d-flex">
              //             <div className="flex-1">
              //               <span title={(isEnabled) ? "" : "There are Questions that depend on this competency" }>
              //                 <TextInput
              //                   id={`competency-${id}`}
              //                   key={id}
              //                   multiline={true}
              //                   rowsMax={6}
              //                   nocontrol={true}
              //                   defaultValue={name}
              //                   helperText="Competency Name"
              //                   onChange={e=> {
              //                     this.handleCompetency(e, id)
              //                   }}
              //                 />
              //
              //               </span>
              //             </div>
              //             <div className="align-self-center">
              //             { delIcon }
              //             </div>
              //             </div>
              //           </Grid>
              //         )
              //       })
              //     }
              //     </Grid>
              //   </Grid>
              //
              // </div>
              //
              // <div>
              //   <Grid item xs={12} md={8}>
              //   <div className="d-flex justify-content-end mt-24 pb-24 pr-160 mr-16">
              //     <CustomOutlinedButton
              //       className="buttonnoto c-blue"
              //       onClick={e => {
              //         e.preventDefault()
              //         this.setState({competencyopen:true})
              //       }}
              //     >ADD</CustomOutlinedButton>
              //   </div>
              //   </Grid>
              // </div>
}

            </Paper>

            <LocalForm
              model="settings"
              getDispatch={(dispatch) => this.attachDispatch(dispatch)}
              initialState={initialState}
              onUpdate={(form) => this.handleUpdate(form)}
              onSubmit = {(values) => this.handleSubmit(values)}
            >

              <Paper use="templates" className="mb-24 innerbar">
                  <InnerBar text="Test Templates"/>
                  <div className="pl-24 pr-24 pt-24 pb-24">
                    <Grid item xs={12} md={12}>
                      <Typography className="h6 mb-12">Scoring</Typography>
                      { levels &&
                        levels.map(level => {

                          return (
                            <LevelSubForm numOfCols={6} key={`level-${level.name}`} levelname={level.name} track={track} parentstate={this.state.levelErrors[level.name]} base="settings"/>
                          )
                        })
                      }
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <Typography className="h6  mt-32 mb-12">Competency Occurrence</Typography>
                      {
                        this.state.localCompetencies.length > 0 && this.state.localCompetencies.map(competency => {
                          return (
                            <CompetencySubForm
                              numOfCols={6}
                              key={`competency-${competency.id}`}
                              competency={competency}
                              base="settings"
                              totalRatio={this.state.localCompetencies.map(a=>a.ratio).reduce((a,b)=>parseInt(a,10)+parseInt(b,10))}
                              handleCompetency={this.handleCompetency.bind(this)}
                            />
                          )
                        })
                      }
                    </Grid>

                    <Grid item xs={12} md={4}>

                      <Typography className="h6 mt-32 mb-12">Default Number of Questions</Typography>
                      <TextInput
                        id="settings-template_questions"
                        model="settings.template_questions"
                        required
                        error={!this.state.numberValid}
                        helperText="Number of questions to be served"
                        validators={{
                          required: val=> isNumeric(val)
                        }}
                      />

                      <Typography className="h6 mt-32 mb-12">Test Time Limit</Typography>
                      <TextInput
                        id="settings-template_minutes"
                        model="settings.template_minutes"
                        required
                        error={!this.state.minutesValid}
                        helperText="Test time limit in minutes"
                        validators={{
                          required: val=> isNumeric(val)
                        }}
                      />

                      <Typography className="h6 mb-8">Question Time Limit</Typography>
                      <Control.select
                        model="qsqs"
                        id="settings-question_seconds"
                        value={this.state.seconds > 0 ? this.state.seconds : this.props.seconds}
                        component={FormSelect}
                        required
                        error={!this.state.secondsValid}
                        onChange={(e) => this.handleChangeSeconds(e)}
                        helperText="Question time limit in seconds"
                        className="w-100"
                        inputProps={{
                          className: 'pl-16'
                        }}
                        validators={{
                          required: (val) => {
                            return isNumeric(val)
                          }
                        }}

                      >
                      {
                        [15, 20, 25, 30, 35, 40, 45, 50, 55, 60].map( unit => {
                          return <MenuItem key={unit} value={unit}>{unit}</MenuItem>
                        })
                      }
                      </Control.select>
                    </Grid>
                </div>
              </Paper>

              <Paper use="tags" className="mb-24 innerbar">
                <InnerBar text="Tags"/>

                <div className="pl-24 pr-24 pt-24 pb-24">
                  <Typography className="h6 mb-24">Available Tags</Typography>
                  <Grid item xs={12} md={8}>
                    <Grid item xs={12} container spacing={24}>
                      {
                        this.state.localTags.map( tag => {
                          const {id, name, questions } = tag
                          const delIcon = (
                            <IconButton title="Delete this tag"
                              onClick={e=>{
                                if (questions > 0) {
                                  this.setState({
                                    current_tag: id,
                                    showTagDialog: true,
                                    tagQuestions: questions
                                  })
                                } else {
                                  this.deleteTag(id)
                                }
                            }}>
                              <Icon style={{color: 'black'}} aria-label="Delete">delete_forever</Icon>
                            </IconButton>
                          )
                          return (
                            <Grid item xs={12} sm={6} key={`tagform-${id}`}>
                            <div className="d-flex">
                              <div className="flex-1">
                                <span>
                                  <TextInput
                                    id={`tag-${id}`}
                                    key={id}
                                    multiline={true}
                                    rowsMax={6}
                                    nocontrol={true}
                                    defaultValue={name}
                                    helperText="Tag Name"
                                    onChange={e=> {
                                      this.handleTag(e, id)
                                    }}
                                  />

                                </span>
                              </div>
                              <div className="align-self-center">
                              { delIcon }
                              </div>
                              </div>
                            </Grid>
                          )
                        })
                      }
                     </Grid>
                    </Grid>
                    </div>
                <div>


                  <Grid item xs={12} md={8}>
                  <div className="d-flex justify-content-end mt-24 pb-24 pr-16">
                    <CustomOutlinedButton
                      className="buttonnoto c-blue"
                      onClick={e => {
                        e.preventDefault()
                        this.setState({tagopen:true})
                      }}
                    >ADD</CustomOutlinedButton>
                  </div>
                  </Grid>
                </div>
              </Paper>

              <Paper use="level_labels" className="mb-24 innerbar">
                <InnerBar text="Level Labels and Descriptions"/>
                <div className="pl-24 pr-24 pt-24 pb-24">
                { levels &&
                  levels.map(level => {

                    return (
                      <LevelLabels key={`level-${level.name}`} levelname={level.name} track={track} parentstate={this.state.levelErrors[level.name]} base="settings"/>
                    )
                  })
                }
                </div>
              </Paper>

              <Paper use="disclaimer" className="mb-24 innerbar">
                <InnerBar text="Legal Disclaimer"/>
                <div className="pl-24 pr-24 pt-24 pb-24">
                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Title</Typography>
                    <TextInput
                      id="settings-disclaimer_label"
                      model="settings.disclaimer_label"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Legal Disclaimer Title"
                      error={!this.state.disclaimerLabelValid}
                      helperText="Legal Disclaimer Title"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Body</Typography>
                    <TextInput
                      id="settings-disclaimer_text"
                      model="settings.disclaimer_text"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Legal Disclaimer Text"
                      error={!this.state.disclaimerTextValid}
                      helperText="Legal Disclaimer Text"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>
                </div>
              </Paper>

              <Paper use="email_disclaimer" className="mb-24 innerbar">
                <InnerBar text="Email Footer Disclaimer"/>
                <div className="pl-24 pr-24 pt-24 pb-24">
                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Title</Typography>
                    <TextInput
                      id="settings-email_disclaimer_label"
                      model="settings.email_disclaimer_label"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Footer Disclaimer Title"
                      error={!this.state.emailDisclaimerLabelValid}
                      helperText="Email Footer Disclaimer Title"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Body</Typography>
                    <TextInput
                      id="settings-email_disclaimer_text"
                      model="settings.email_disclaimer_text"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Footer Disclaimer Text"
                      error={!this.state.emailDisclaimerTextValid}
                      helperText="Email Footer Disclaimer Text"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>
                </div>
              </Paper>

              <Paper use="emails" className="mb-24 innerbar">
                <InnerBar text="System Emails"/>
                <div className="pl-24 pr-24 pt-24 pb-24">
                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Global Admin Email (comma separated)</Typography>
                    <TextInput
                      id="settings-admin_email"
                      model="settings.admin_email"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Global Administrator Email"
                      error={!this.state.adminMailValid}
                      helperText="Global Administrator Email"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Test Results Email</Typography>
                    <TextInput
                      id="settings-mail_certificate_title"
                      model="settings.mail_certificate_title"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Title"
                      error={!this.state.certificateTitleValid}
                      helperText="Email Title"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Password Reset Email</Typography>
                    <TextInput
                      id="settings-mail_reset_title"
                      model="settings.mail_reset_title"
                      multiline={true}
                      rowsMax={6}
                      required
                      placeholder="Email Title"
                      error={!this.state.resetTitleValid}
                      helperText="Email Title"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                    <TextInput
                      id="settings-mail_reset_body"
                      model="settings.mail_reset_body"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Body Text"
                      error={!this.state.resetBodyalid}
                      helperText="Email Body Text"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Account Confirmation Email</Typography>
                    <TextInput
                      id="settings-mail_confirm_title"
                      model="settings.mail_confirm_title"
                      multiline={true}
                      rowsMax={6}
                      required
                      placeholder="Email Title"
                      error={!this.state.confirmTitleValid}
                      helperText="Email Title"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                    <TextInput
                      id="settings-mail_confirm_body"
                      model="settings.mail_confirm_body"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Body Text"
                      error={!this.state.confirmBodyValid}
                      helperText="Email Body Text"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Account Termination Email</Typography>
                    <TextInput
                      id="settings-mail_terminate_user_title"
                      model="settings.mail_terminate_user_title"
                      multiline={true}
                      rowsMax={6}
                      required
                      placeholder="Email Title"
                      error={!this.state.terminateTitleValid}
                      helperText="Email Title"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                    <TextInput
                      id="settings-mail_terminate_user_body"
                      model="settings.mail_terminate_user_body"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Body Text"
                      error={!this.state.terminateBodyValid}
                      helperText="Email Body Text"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Purchase Receipt Email</Typography>
                    <TextInput
                      id="settings-mail_receipt_title"
                      model="settings.mail_receipt_title"
                      multiline={true}
                      rowsMax={6}
                      required
                      placeholder="Email Title"
                      error={!this.state.receiptTitleValid}
                      helperText="Email Title"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                    <TextInput
                      id="settings-mail_receipt_body"
                      model="settings.mail_receipt_body"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Body Text (with price)"
                      error={!this.state.receiptBodyalid}
                      helperText="Email Body Text (@@AMOUNT@@: shortcode for price)"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                    <TextInput
                      id="settings-mail_receipt_free_body"
                      model="settings.mail_receipt_free_body"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Body Text (free test)"
                      error={!this.state.receiptFreeBodyalid}
                      helperText="Email Body Text (free test)"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Registration Reminder</Typography>
                    <TextInput
                      id="settings-mail_preregister_title"
                      model="settings.mail_preregister_title"
                      multiline={true}
                      rowsMax={6}
                      required
                      placeholder="Email Title"
                      error={!this.state.preregisterTitleValid}
                      helperText="Email Title"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                    <TextInput
                      id="settings-mail_preregister_body"
                      model="settings.mail_preregister_body"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Body Text"
                      error={!this.state.preregisterBodyalid}
                      helperText="Email Body Text"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                </div>
              </Paper>

              <Paper use="b2b_free_plan" className="mb-24 innerbar">
                <InnerBar text="B2B Free Plan Settings"/>
                <div className="pl-24 pr-24 pt-24 pb-24">
                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Number of free Vouchers</Typography>
                    <TextInput
                      id="settings-free_plan_redeems"
                      model="settings.free_plan_redeems"
                      multiline={true}
                      rowsMax={6}
                      required
                      placeholder="Free Vouchers"
                      error={!this.state.b2bFreePlanRedeemsValid}
                      helperText="Set to 0 to disable"
                      validators={{
                        required: val=> isNumeric(val, true)
                      }}
                    />
                    <Typography className="h6 mb-12">Discount percentage</Typography>
                    <TextInput
                      id="settings-free_plan_discount"
                      model="settings.free_plan_discount"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Discount percentage"
                      error={!this.state.b2bFreePlanDiscountValid}
                      helperText="Discount (0 - 100%)"
                      validators={{
                        required: val=> isNumeric(val, true, 100)
                      }}
                    />
                  </Grid>
                </div>
              </Paper>

              <Paper use="emails" className="mb-24 innerbar">
                <InnerBar text="B2B Emails"/>
                <div className="pl-24 pr-24 pt-24 pb-24">
                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Account Confirmation Email (B2B)</Typography>
                    <TextInput
                      id="settings-mail_b2b_confirm_title"
                      model="settings.mail_b2b_confirm_title"
                      multiline={true}
                      rowsMax={6}
                      required
                      placeholder="Email Title"
                      error={!this.state.confirmB2BTitleValid}
                      helperText="Email Title"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                    <TextInput
                      id="settings-mail_b2b_confirm_body"
                      model="settings.mail_b2b_confirm_body"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Body Text"
                      error={!this.state.confirmB2BBodyValid}
                      helperText="Email Body Text"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">New Voucher Issued</Typography>
                    <TextInput
                      id="settings-mail_new_voucher_title"
                      model="settings.mail_new_voucher_title"
                      multiline={true}
                      rowsMax={6}
                      required
                      placeholder="Email Title"
                      error={!this.state.newVoucherTitleValid}
                      helperText="Email Title"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                    <TextInput
                      id="settings-mail_new_voucher_body"
                      model="settings.mail_new_voucher_body"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Body Text"
                      error={!this.state.newVoucherBodyValid}
                      helperText="Email Body Text"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Voucher Revoked</Typography>
                    <TextInput
                      id="settings-mail_revoked_voucher_title"
                      model="settings.mail_revoked_voucher_title"
                      multiline={true}
                      rowsMax={6}
                      required
                      placeholder="Email Title"
                      error={!this.state.revokedVoucherTitleValid}
                      helperText="Email Title"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                    <TextInput
                      id="settings-mail_revoked_voucher_body"
                      model="settings.mail_revoked_voucher_body"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Email Body Text"
                      error={!this.state.revokedVoucherBodyValid}
                      helperText="Email Body Text"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>

                  {
                    // B2B USER REVOCATION EMAIL
                    // <Grid item xs={12} md={4}>
                    //   <Typography className="h6 mb-12">Account Terminated</Typography>
                    //
                    // </Grid>
                  }

                </div>
              </Paper>

              <Paper use="test" className="mb-24 innerbar">
                <InnerBar text="Global Settings"/>
                <div className="pl-24 pr-24 pt-24 pb-24">
                  <Grid item xs={12} md={4}>
                    <Typography className="h6 mb-12">Test Price</Typography>
                    <TextInput
                      id="settings-test_price"
                      model="settings.test_price"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Test Price €"
                      error={!this.state.testPriceValid}
                      helperText="Test Price €"
                      validators={{
                        required: val=> isNumeric(val)
                      }}
                    />

                    <Typography className="h6 mb-12">Test URL (for emails)</Typography>
                    <TextInput
                      id="settings-test_url"
                      model="settings.test_url"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Test App Url"
                      error={!this.state.testUrlValid}
                      helperText="Test App Url"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />

                    <Typography className="h6 mb-12">Admin URL (for emails)</Typography>
                    <TextInput
                      id="settings-system_url"
                      model="settings.system_url"
                      multiline={true}
                      rowsMax={6}
                      placeholder="System App Url"
                      error={!this.state.systemUrlValid}
                      helperText="System App Url"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />

                    <Typography className="h6 mb-12">B2B Console URL (for emails)</Typography>
                    <TextInput
                      id="settings-b2b_url"
                      model="settings.b2b_url"
                      multiline={true}
                      rowsMax={6}
                      placeholder="B2B Console Url"
                      error={!this.state.b2bUrlValid}
                      helperText="B2B Console Url"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />

                    <Typography className="h6 mb-12">B2B Templates Subtitle (Test Taker App)</Typography>
                    <TextInput
                      id="settings-b2b_templates_title"
                      model="settings.b2b_templates_title"
                      multiline={true}
                      rowsMax={6}
                      placeholder="B2B Templates Subtitle"
                      error={!this.state.b2bTemplatesTitleValid}
                      helperText="B2B Templates Subtitle (@@NAME@@: B2B Name)"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />

                    <Typography className="h6 mb-12">FROM address</Typography>
                    <TextInput
                      id="settings-from_email"
                      model="settings.from_email"
                      multiline={true}
                      rowsMax={6}
                      placeholder="FROM address"
                      error={!this.state.fromEmailValid}
                      helperText="FROM address (outgoing emails)"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />

                    <Typography className="h6 mb-12">Accounting email address</Typography>
                    <TextInput
                      id="settings-accounting_email"
                      model="settings.accounting_email"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Accounting email address"
                      error={!this.state.accountingEmailValid}
                      helperText="Accounting email address (for receipts)"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />

                    <Typography className="h6 mb-12">Contact phone</Typography>
                    <TextInput
                      id="settings-contact_phone"
                      model="settings.contact_phone"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Contact phone"
                      error={!this.state.contactPhoneValid}
                      helperText="Contact phone"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />

                    <Typography className="h6 mb-12">Contact address</Typography>
                    <TextInput
                      id="settings-address"
                      model="settings.address"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Contact address"
                      error={!this.state.addressValid}
                      helperText="Contact address"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />

                    <Typography className="h6 mb-12">VAT ID</Typography>
                    <TextInput
                      id="settings-vat"
                      model="settings.vat"
                      multiline={true}
                      rowsMax={6}
                      placeholder="VAT ID"
                      error={!this.state.vatValid}
                      helperText="VAT ID"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />

                    <Typography className="h6 mb-12">Terms of Service URL</Typography>
                    <TextInput
                      id="settings-terms_of_service"
                      model="settings.terms_of_service"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Terms of Service URL"
                      error={!this.state.termsValid}
                      helperText="Terms of Service URL"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />

                    <Typography className="h6 mb-12">Privacy Policy URL</Typography>
                    <TextInput
                      id="settings-privacy_policy"
                      model="settings.privacy_policy"
                      multiline={true}
                      rowsMax={6}
                      placeholder="Privacy Policy URL"
                      error={!this.state.policyValid}
                      helperText="Privacy Policy URL"
                      validators={{
                        required: val=> isRequired(val)
                      }}
                    />
                  </Grid>
                </div>
              </Paper>

            </LocalForm>

            <div className="d-flex justify-content-end mt-40">
              { saveButton }
            </div>

            <SkillForm
              id="settings-skills-dialog"
              open={this.state.skillopen}
              handleClose={ this.handleClose.bind(this) }
              addSkill={this.addSkill.bind(this)}
              skillError={this.state.skillError}
            />

{
            // <CompetencyForm
            //   id="settings-competencies-dialog"
            //   open={this.state.competencyopen}
            //   handleClose={ this.handleClose.bind(this) }
            //   addCompetency={this.addCompetency.bind(this)}
            //   competencyError={this.state.competencyError}
            // />
}

            <TagForm
              id="settings-tags-dialog"
              open={this.state.tagopen}
              handleClose={ this.handleClose.bind(this) }
              addTag={this.addTag.bind(this)}
              tagError={this.state.tagError}
            />

            <CustomDialog
              id="delete-tag-dialog"
              qid={this.state.current_tag}
              isopen={this.state.showTagDialog}
              handleClose={this.hideDialog.bind(this)}
              handleAccept={this.deleteTag.bind(this)}
              title={`Delete this tag?`}
            >
              This tag is associated with {this.state.tagQuestions} question(s). Deleting will remove existing associations.
            </CustomDialog>

          </Grid>
        </Grid>
      </MuiThemeProvider>
    )
  }
}

const Settings = connect(mapStateToProps, mapDispatchToProps)(ConnectedSettings);

export default Settings



// WEBPACK FOOTER //
// ./src/js/components/Settings.js